// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__XDosd","disabled":"FileBtn_disabled__1bSFI","warn":"FileBtn_warn__3-hCl","fade":"FileBtn_fade__3gbPG"};